import { getCleanShopName } from '~/utils/shop-name'

export interface RestaurantCardProps {
  id: string
  name: string
  location: string
  cuisine: string
  description: string
  rating: number
  reviewCount: number
  priceLevel: string
  imageUrl: string
  area?: string
  distance?: string
  category?: string
  isHyakumeiten?: boolean
  awards?: { name: string; snapshotId?: string; url?: string }[]
  hasMenu?: boolean
}

export function computePriceLevel(budgetMin: number | null | undefined, budgetMax: number | null | undefined): string {
  if (!budgetMin && !budgetMax) return ''
  if (budgetMin && budgetMax) {
    if (budgetMin === budgetMax) return `¥${budgetMin.toLocaleString()}`
    return `¥${budgetMin.toLocaleString()}~${budgetMax.toLocaleString()}`
  }
  if (budgetMin) return `¥${budgetMin.toLocaleString()}~`
  if (budgetMax) return `~¥${budgetMax.toLocaleString()}`
  return ''
}

export function mapShopToCardProps(shop: any, t?: any): RestaurantCardProps {
  const address = shop.translation?.address || ''
  const location = address ? address.split(' ')[0] : ''
  const area = location

  // Using a generic fallback for cuisine for now until API provides inline category names
  const cuisine = shop.translation?.category || ''
  const category = cuisine

  const description = shop.translation?.description 
    || shop.translation?.prCommentContent 
    || ''

  const rawRating = shop.ratingScore !== null ? Number(shop.ratingScore) : 0
  const rating = isNaN(rawRating) ? 0 : rawRating
  
  const reviewCount = shop.reviewCount || 0
  
  // Display actual numeric ranges instead of ¥¥¥¥
  const priceLevel = computePriceLevel(
    shop.dinnerBudgetMin ?? shop.lunchBudgetMin,
    shop.dinnerBudgetMax ?? shop.lunchBudgetMax
  )

  let imageUrl = '/placeholder-restaurant.svg'
  if (shop.imageUrl) {
    imageUrl = shop.imageUrl
  } else if (shop.photos && Array.isArray(shop.photos) && shop.photos.length > 0) {
    imageUrl = shop.photos[0]
  }

  return {
    id: String(shop.id || ''),
    name: getCleanShopName(shop.translation?.name, shop.translation?.alias) || (t ? t('unnamedRestaurant') : 'Unnamed Restaurant'),
    location,
    cuisine,
    description,
    rating,
    reviewCount,
    priceLevel,
    imageUrl,
    area,
    category,
    distance: shop.distance ? `${Math.round(shop.distance)}m` : (t ? t('nearby') : 'Nearby'),
    isHyakumeiten: Array.isArray(shop.translation?.awards) && shop.translation.awards.length > 0,
    awards: Array.isArray(shop.translation?.awards) ? shop.translation.awards : undefined,
    hasMenu: shop.translation?.hasMenu ?? (Array.isArray(shop.translation?.menus) && shop.translation.menus.length > 0),
  }
}
